import React from 'react';

export default class FilePreview extends React.Component {

  deleteFile = e => {
    this.props.deleteFile(this.props.el.key);
  };


  render(){
    return(
      <li className="file-item">
        <div className="file-item-inner">
          <i className="file-icon ic-file-ico"/>
          <div className="file-link">
            <p className="file-link-active">{this.props.el.file_name}</p>
            <p className="file-link-size">{parseInt(this.props.el.file_size / 1000)} KB</p>
          </div>
        </div>
        <span onClick={this.deleteFile} className="file-delete">
          <i className="ic-close-ico"/>
        </span>
      </li>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/create_workshop/create_module/create_question/FilePreview.jsx